
export enum MediaMarketTypeEnum {
    US_MEDIA_MARKETS = 'US_MEDIA_MARKETS',
    UK_MEDIA_MARKETS = 'UK_MEDIA_MARKETS',
    CA_MEDIA_MARKETS = 'CA_MEDIA_MARKETS',
}

export const mediaMarketTypeToDisplayStringMap: Map<MediaMarketTypeEnum, string> = new Map([
    [ MediaMarketTypeEnum.US_MEDIA_MARKETS,  'U.S. Media Markets' ],
    [ MediaMarketTypeEnum.UK_MEDIA_MARKETS,  'U.K. Media Markets' ],
    [ MediaMarketTypeEnum.CA_MEDIA_MARKETS, 'Canadian Media Markets' ],
]);

/**
 * Brittle. Relationship between media markets and geo restrictions should come from backend
 */
export const mediaMarketTypeToGeoIdsMap: Map<MediaMarketTypeEnum, number[]> = new Map([
    //                                       US   NA
    [MediaMarketTypeEnum.US_MEDIA_MARKETS,  [433, 11]],
    //                                       CAD  NA
    [MediaMarketTypeEnum.CA_MEDIA_MARKETS, [431, 11]],
    //                                       UK   EU
    [MediaMarketTypeEnum.UK_MEDIA_MARKETS,  [385, 9]]
]);
